import InvalidVizModal from "./invalidVizModal";

export default InvalidVizModal;
